import { get } from './get';
import { list } from './list';
import { send } from './send';

export { type EmailSendPayload } from './send';
export { emailSendPayloadSchema } from './send.schema';

export const email = {
  list,
  send,
  get,
};
